/**
 * Converts a string to title case.
 *
 * @param str - The input string that needs to be converted to title case.
 * @returns A string where each word has its first letter capitalized and the rest of the letters in lowercase.
 *
 * @example
 * const result = toTitleCase("hello world");
 * console.log(result); // Output: "Hello World"
 */
export const toTitleCase = (str: string) =>
  str.replace(
    /\w\S*/g,
    (txt: string) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
